import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { Language, useTranslation } from '../translations';

interface LanguageSelectorProps {
  onLanguageChange: (lang: Language) => void;
}

export function LanguageSelector({ onLanguageChange }: LanguageSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useTranslation();

  const languages: Record<Language, string> = {
    NL: 'Nederlands',
    FR: 'Français',
    EN: 'English'
  };

  return (
    <div className="relative">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-1.5 rounded-full border border-gray-200 hover:border-jaimy-red text-gray-600 hover:text-jaimy-red transition-all"
      >
        <Globe className="h-4 w-4" />
        <span className="text-sm font-medium">{lang}</span>
      </button>
      
      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          ></div>
          <div className="absolute top-full right-0 mt-2 w-40 bg-white rounded-lg shadow-lg py-1 z-20 border border-gray-100">
            {Object.entries(languages).map(([code, name]) => (
              <button
                key={code}
                onClick={() => {
                  onLanguageChange(code as Language);
                  setIsOpen(false);
                }}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 hover:text-jaimy-red transition-colors ${
                  lang === code ? 'text-jaimy-red font-medium' : 'text-gray-600'
                }`}
              >
                {name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}